// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file webgame/v1/geo.proto (package webgame.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file webgame/v1/geo.proto.
 */
export const file_webgame_v1_geo: GenFile = /*@__PURE__*/
  fileDesc("ChR3ZWJnYW1lL3YxL2dlby5wcm90bxIKd2ViZ2FtZS52MSIiCgZMYXRMbmcSCwoDbGF0GAEgASgBEgsKA2xuZxgCIAEoASJMCgZCb3VuZHMSDwoHbWluX2xhdBgBIAEoARIPCgdtaW5fbG5nGAIgASgBEg8KB21heF9sYXQYAyABKAESDwoHbWF4X2xuZxgEIAEoAUI3WjVnaXRodWIuY29tL21hZmlhZ28vc2VydmVyL2dlbi9nby93ZWJnYW1lL3YxO3dlYmdhbWV2MWIGcHJvdG8z");

/**
 * @generated from message webgame.v1.LatLng
 */
export type LatLng = Message<"webgame.v1.LatLng"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lng = 2;
   */
  lng: number;
};

/**
 * Describes the message webgame.v1.LatLng.
 * Use `create(LatLngSchema)` to create a new message.
 */
export const LatLngSchema: GenMessage<LatLng> = /*@__PURE__*/
  messageDesc(file_webgame_v1_geo, 0);

/**
 * An axis-aligned lat/lng rectangle. min < max on both axes; a box that
 * crosses the antimeridian is rejected rather than wrapped.
 *
 * @generated from message webgame.v1.Bounds
 */
export type Bounds = Message<"webgame.v1.Bounds"> & {
  /**
   * @generated from field: double min_lat = 1;
   */
  minLat: number;

  /**
   * @generated from field: double min_lng = 2;
   */
  minLng: number;

  /**
   * @generated from field: double max_lat = 3;
   */
  maxLat: number;

  /**
   * @generated from field: double max_lng = 4;
   */
  maxLng: number;
};

/**
 * Describes the message webgame.v1.Bounds.
 * Use `create(BoundsSchema)` to create a new message.
 */
export const BoundsSchema: GenMessage<Bounds> = /*@__PURE__*/
  messageDesc(file_webgame_v1_geo, 1);

